import { createContext } from "react";

export const AuthContext = createContext({
  isLoggedIn: false,
  userId: null,
  token: null,
  tokenExpirationDate: null,
  email: null,
  surname: null,
  firstName: null,
  username: null,
  role: null,
  login: () => {},
  logout: () => {},
});
